// 客服信息模块
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue';

export default {
    data() {
        return {
            list: [],
            imgUrl: this.imgUrl,
            bannerUrl: this.bannerUrl,
            // 轮播图集合
            bannerList: [],
            // 地区
            region: '',
            newsList: [],
            noticeList: [],
            baseUrl: this.baseUrl,
        }
    },
    components: {
        ServiceInformation
    },
    methods: {
        // 获取同一路径下的项目包
        getPackageByUrl(url) {
            this.$post('package/get_package_by_url', {
                url: url,
                offset: 0,
                length: 999
            }).then(res => {
                // 处理数组
                this.handleArray(res.data.result.data)
                let firstPackageId = res.data.result.data[0].id
            })
        },

        // 处理数组
        handleArray(arr) {
            // 先取出所有年度
            let yearsList = []
            let list = []
            arr.map(item => {

                item.package_attribute_value.map(item2 => {
                    if (item2.type === '年度') {
                        list.push({
                            year: Number.parseInt(item2.name)
                        })
                    } else if (item2.type === '地区') {
                        this.region = item2.name
                    }
                })
            })

            // 去掉重复的年度
            if (list.length === 1) {
                yearsList = list
            } else {
                var obj = {}
                yearsList = list.reduce((item, next) => {
                    obj[next.year] ? '' : obj[next.year] = true && item.push(next)
                    return item
                }, [])
            }

            // 向数组中添加年度相同的项目包
            for (let i = 0; i < yearsList.length; i++) {

                yearsList[i].list = []
                for (let j = 0; j < arr.length; j++) {

                    for (let k = 0; k < arr[j].package_attribute_value.length; k++) {
                        let data = arr[j].package_attribute_value[k]
                        if (data.type === '年度' && data.name == yearsList[i].year) {
                            yearsList[i].list.push(arr[j])
                        }
                    }
                }
            }

            this.list = yearsList.sort((a, b) => b.year - a.year);
        },

        // 计算状态
        state(start_study_time, end_study_time) {
            if (!this.$isAbnormal(start_study_time) && !this.$isAbnormal(end_study_time)) {
                let study = new Date(start_study_time).getTime()
                let end = new Date(end_study_time).getTime()
                let time = new Date().getTime()
                if (time > end) {
                    return "已完成"
                } else if (time < end && time > study) {
                    return "学习中"
                } else {
                    return "报名中"
                }
            }
        },

        // 跳转到项目包主页
        toProjectHomePage(id) {
            this.$router.push({
                path: "/pojecthomepage",
                query: {
                    package_id: id
                }
            })
        },

        // 根据shop_id获取店铺详情
        getShopInfo(shop_id, url) {
            this.$post('shops/get', {
                url: url
            }).then(res => {
                this.$store.state.store = res.data.result;
                sessionStorage.setItem("store", JSON.stringify(this.$store.state.store));

                // 获取项目包
                this.getPackageByUrl(url);

                // 获取轮播图
                this.getBanner();
            });

            // 将店铺的信息从浏览器缓存中取出并转成对象存储在vuex
            this.$store.state.store = JSON.parse(sessionStorage.getItem("store"))

            // 如果用户token为空且浏览器缓存中存有tpid则进入
            if (!this.$store.state.id && sessionStorage.getItem("tpid")) {
                // 从浏览器缓存中获取tpid并赋值到用户token
                this.$store.state.id = sessionStorage.getItem("tpid")

                // 从浏览器缓存中获取tpname并赋值到用户姓名
                this.$store.state.name = sessionStorage.getItem("tpname")

                // 从浏览器缓存中获取tpuserId并赋值到用户userId
                this.$store.state.userId = sessionStorage.getItem("tpuserId")

                // 从浏览器缓存中获取tpshopid并赋值到店铺id
                this.$store.state.shopId = sessionStorage.getItem("tpshopid")
            }
        },

        // 获取轮播图
        getBanner() {
            this.$post('banner/search', {
                shop_id: 8,
                offset: 0,
                length: 999
            }).then(res => {
                this.bannerList = res.data.result.data
            })
        },

        // 点击通知或指南进行跳转到详情页面
        handleClick(type, item) {
            this.$router.push({
                path: '/projectnews',
                query: {
                    id: item.id,
                    type: type
                }
            })
        },

        // 获取新闻
        getNewsList() {
            this.$post('productNews/getProductNewsByUrl', {
                url: window.location.href.split('/#')[0]
            }).then(res => {
                if (res.data.status === 'success') {
                    this.newsList = res.data.result;
                }
            });
        },

        getNoticeList() {
            this.$post('productNotices/getProductNoticesByUrl', {
                url: window.location.href.split('/#')[0]
            }).then(res => {
                if (res.data.status === 'success') {
                    this.noticeList = res.data.result;
                }
            });
        }
    },

    created() {

        // 线上
        let url = window.location.href.split('/#')[0]
        // let url = 'https://ljjs-test.ca163.net';
        // let url = 'https://tsjs-test.ca163.net';

        // 本地
        // let url = 'https://ljjs.ca163.net'
        // let url = 'https://tsedu.ca163.net'

        // 获取店铺信息
        this.getShopInfo(8, url);

        this.getNewsList();
        this.getNoticeList();
    },
}
